import React from "react";
// import Navbar from "../Navbar";
// import Header from "../Header";
// import ConnectCustomers from "../ConnectCustomers";
// import Marketing from "../Marketing";
// import Cards from "../Cards";
// import CardGrid from "../CardGrid";
// import Ticker from "../Ticker";
// import FAQ from "../FAQ";
// import Meet from "../Meet";
// import CardGrid from '../Home/Components/CardGrid/CardGrid.js'
// import Footer from "../Footer";
// import End from "../End";


import ConnectCustomers from '../Home/Components/ConnectCustomers/ConnectCustomers.js'
import Marketing from '../Home/Components/Marketing/Marketing.js'
 import Cards from '../Home/Components/Cards/Cards.js'
import CardGrid from '../Home/Components/CardGrid/CardGrid.js'
 import Ticker from '../Home/Components/Ticker/Ticker.js'
import FAQ from './Components/FAQ/FAQ.jsx'
import Meet from './Components/Meet/Meet.jsx'


function Home() {
  return (
    <div>
      {/* <Navbar />
      <Header /> */}
      <ConnectCustomers />
      <Marketing />
      <Cards />
      <CardGrid />
      <Ticker />
      <FAQ />
      <Meet />
      {/* <Footer />
      <End /> */}
    </div>
  );
}

export default Home;


